import React, { useState, useEffect } from "react";
import Layout from "../shared/Layout";
import { Toaster, toast } from "react-hot-toast";
import DataTable from 'react-data-table-component';
import { DeleteCustomEnquiryById, deleteEnquiryById, GetCustomEnquiry, GetEnquiryAll } from "../../_services";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { handleExport } from "../../_services/excelExportService";

const CustomEnquiry = () => {
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [enquiryData, setEnquiryData] = useState([]);

    const fetchEnquiryAll = async () => {
        try {
            const data = await GetCustomEnquiry();
            setEnquiryData((prevData) => {
                if (JSON.stringify(prevData) !== JSON.stringify(data)) {
                    const sortedData = data?.sort((a, b) => {
                        return new Date(b.createdDate) - new Date(a.createdDate);
                    });
                    return sortedData;
                }
                return prevData;
            })
        } catch (error) {
            // toast.error(error.message);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchEnquiryAll();
    }, [])

    const onDeleteEnquiry = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (!isConfirmed) {
            return;
        }
        const data = await DeleteCustomEnquiryById(id);
        if (data.isSuccess === 1) {
            fetchEnquiryAll();
            toast.success("Delete Successfully");
        }
    };

    useEffect(() => {
        if (searchTerm) {
            const filtered = enquiryData.filter(item =>
                item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.emailId.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.contactNo.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(enquiryData);
        }
    }, [searchTerm, enquiryData]);

    const excelSheetData = enquiryData?.map((item, index) => ({
        Index: index + 1, // Adding an index starting from 1
        Name: item.name,
        EmailId: item.emailId,
        ContactNo: item.contactNo,
        Quantity: item.quantity,
        Message: item.remark,
        Address: item.address,
    }));

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: false,
            width: '150px'
        },
        {
            name: 'Email Id',
            selector: row => row.emailId,
            sortable: false,
            width: '200px'
        },
        {
            name: 'Contact No.',
            selector: row => row.contactNo,
            sortable: false,
            width: '120px',
        },
        {
            name: 'Quantity',
            selector: row => row.quantity,
            sortable: false,
            width: '100px',
        },
        {
            name: 'Address',
            selector: row => row.address,
            sortable: false,
            minwidth: '200px'
        },
        {
            name: 'Message',
            selector: row => row.remark,
            sortable: false,
            minwidth: '200px'
        },
        {
            name: 'Enquiry Date',
            selector: row => {
                if (row.createdDate) {
                    const date = new Date(row.createdDate);

                    // Convert to Indian Standard Time (IST)
                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

                    // Format Date as dd/mm/yyyy
                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: false,
            width: '180px'
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title='Delete' onClick={() => onDeleteEnquiry(row?.enquiryId)} className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false,
            width: '100px',
        }
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Custom Enquiry</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <button className="export_button" onClick={()=>handleExport(excelSheetData)}><img src="./images/upload.png" alt="" className="export_icon" /><span>Export</span></button>
                    </div>
                </div>
                <div className="datatable mt-3">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>
            </div>
        </Layout>
    )
}

export default CustomEnquiry;